var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCuadrosizq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 76,
    viewBox: "0 0 114 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    width: 38,
    height: 38,
    fill: "#0A826C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 38,
    width: 38,
    height: 38,
    fill: "#2AD0B2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "#4DD68D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuadrosizq);
export default __webpack_public_path__ + "static/media/Cuadros izq.6b3dfa6ccdfec7f16b25aecc0367ed4c.svg";
export { ForwardRef as ReactComponent };